import { buildRequestQuoteSelector } from 'store/selectors/requestQuotes.selector';
import RequestHotelsRepository from 'services/repositories/RequestHotelsRepository';
import { actionCreators as requestActionCreators } from 'store/actions/metaDatabase.requests.actions';

export function attachServices(requestQuoteId, requestHotelId, vendorServiceIds)
{
    return async (dispatch, getState) =>
    {
        const requestQuotesRepository = new RequestHotelsRepository();
        const result = await requestQuotesRepository.attachServices(requestHotelId, { vendorServiceIds, requestQuoteId });

        if (!result.isSuccess())
        {
            return;
        }

        const requestQuoteSelector = buildRequestQuoteSelector();
        const requestQuote = requestQuoteSelector(getState(), requestQuoteId);
        dispatch(requestActionCreators._needUpdate(requestQuote.request_id, true));
    };
}
